import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import {
  readCookiePreferences,
  saveCookiePreferences,
  applyAnalyticsToVendors,
  type CookiePreferences as CookiePrefs,
} from '../utils/cookiePreferences';
import './CookiePreferences.css';

const CookiePreferences: React.FC = () => {
  const [analytics, setAnalytics] = useState(true);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const prefs = readCookiePreferences();
    setAnalytics(prefs.analytics);
  }, []);

  const handleSave = () => {
    const next: CookiePrefs = {
      analytics,
      bannerDismissed: true,
    };
    saveCookiePreferences(next);
    applyAnalyticsToVendors(analytics);
    setSaved(true);
    window.setTimeout(() => setSaved(false), 3000);
  };

  return (
    <motion.div
      className="cookie-preferences-page"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, ease: 'easeOut' }}>
      <div className="cookie-preferences-inner">
        <h1 className="cookie-preferences-title">Cookie preferences</h1>
        <p className="cookie-preferences-lead">
          We use cookies and similar technologies to run the site and understand
          how it is used. Analytics and measurement cookies are enabled by
          default; you can turn them off below at any time.
        </p>

        <ul className="cookie-pref-list">
          <li className="cookie-pref-row cookie-pref-row--locked">
            <div className="cookie-pref-text">
              <span className="cookie-pref-name">Necessary</span>
              <span className="cookie-pref-desc">
                Required for basic site functionality and security. Always on.
              </span>
            </div>
            <span className="cookie-pref-badge">Always on</span>
          </li>

          <li className="cookie-pref-row">
            <div className="cookie-pref-text">
              <span className="cookie-pref-name">Analytics &amp; measurement</span>
              <span className="cookie-pref-desc">
                Helps us understand traffic and product usage (Google Analytics
                and PostHog). You can disable this category.
              </span>
            </div>
            <label className="cookie-pref-toggle">
              <input
                type="checkbox"
                checked={analytics}
                onChange={(e) => setAnalytics(e.target.checked)}
                aria-label="Enable analytics and measurement cookies"
              />
              <span className="cookie-pref-slider" />
            </label>
          </li>
        </ul>

        <div className="cookie-pref-actions">
          <button
            type="button"
            className="cookie-pref-save"
            onClick={handleSave}>
            Save preferences
          </button>
          {saved && (
            <span className="cookie-pref-saved" role="status">
              Preferences saved.
            </span>
          )}
        </div>

        <p className="cookie-preferences-foot">
          <Link to="/">← Back to home</Link>
          {' · '}
          <a
            href="https://codec422.com/privacy"
            target="_blank"
            rel="noopener noreferrer">
            Privacy policy
          </a>
        </p>
      </div>
    </motion.div>
  );
};

export default CookiePreferences;
